
import {Component, Prop, Vue, Provide} from "vue-property-decorator";
import ServiceContainer from "@flashpointbv/solar-service-container";

@Component({
  name: 'catalog-product-services',
  components: ServiceContainer().getComponents(),
})
export default class ProductServices extends Vue {
  @Prop({required: true}) productSku!: string;
  @Prop({default: ''}) quoteItemId!: string;
  @Prop({default: () => []}) readonly quoteItemServices!: object[];
  @Prop({default: false}) readonly quoteAutoRun!: boolean;
  @Prop({default: 0}) readonly index!: number;

  @Provide() serviceProductSku = this.productSku;
  @Provide() serviceQuoteItemId = this.quoteItemId;
  @Provide() serviceQuoteItemServices = this.quoteItemServices;
  @Provide() serviceQuoteAutoRun = this.quoteAutoRun;
  @Provide() serviceIndex = this.index;

  private isLoading: boolean = true;
  private isCollapsed: boolean = true;

  private get productServices(): Array<any> {
    return this.$store.getters['ProductServices/productServices'][this.index][this.productSku] ?
        Object.values(this.$store.getters['ProductServices/productServices'][this.index][this.productSku]).sort((a, b) => a['sort_order'] - b['sort_order']) :
        [];
  }

  private toggleCollapse(): void {
    this.isCollapsed = ! this.isCollapsed;
  }

  private async created(): Promise<void> {
    this.$store.commit('ProductServices/SET_CART_ITEM_ID', this.quoteItemId);

    await this.$store.dispatch('ProductServices/getAllProductServices', {
      productSku: this.productSku,
      quoteItemServices: this.quoteItemServices,
      index: this.index,
    });

    this.isLoading = false;

    if (this.$store.getters['ProductServices/selectedProductServices'][this.index][this.productSku]) {
      this.isCollapsed = false;
    }
  }
}
